import { StrictMode, Suspense, use } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { getRecordControl } from "./getRecordControl.ts";
import { ErrorBoundary } from "./ErrorBoundary.tsx";

const recordControlPromise = getRecordControl();

const Wrapper = () => {
  const recordControl = use(recordControlPromise);

  return <App recordControl={recordControl} />;
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary fallback={(message) => <div>Error: {message}</div>}>
      <Suspense fallback={<h2>Loading...</h2>}>
        <Wrapper />
      </Suspense>
    </ErrorBoundary>
  </StrictMode>
);
